import {

  CORE_LOAD_FAQ_REQUEST,
  CORE_LOAD_FAQ_SUCCESS,

  CORE_UPDATE_FAQ_REQUEST,
  CORE_UPDATE_FAQ_SUCCESS,
} from '../../../types'

const initialState = {}
export default {
  faq: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FAQ_REQUEST:
      case CORE_UPDATE_FAQ_REQUEST:
        return initialState

      case  CORE_LOAD_FAQ_SUCCESS:
      case CORE_UPDATE_FAQ_SUCCESS:
        return action.payload

      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/settings/faq/reducer.js